/**
 *
 * Asynchronously loads the component for CoporateRegistration
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CorporateInformationModule = lazyLoad(
  () => import('./index'),
  module => module.CorporateInformationModule,
);
